export function DarkUI() {
  return (
    <svg
      width="171"
      height="96"
      viewBox="0 0 171 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" width="170" height="96" rx="5" fill="#404040" />
      <rect
        x="50.5"
        y="7"
        width="113"
        height="82"
        rx="4.88462"
        fill="#12170F"
      />
      <rect
        x="7.01367"
        y="6.51282"
        width="37.4487"
        height="83.0385"
        rx="4.88462"
        fill="#12170F"
      />
      <circle cx="12.7118" cy="83.8526" r="2.44231" fill="#404040" />
      <rect
        x="18.4121"
        y="83.0385"
        width="14.6538"
        height="1.62821"
        rx="0.814103"
        fill="#404040"
      />
    </svg>
  );
}
